import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UserProfileImage, { getInitials } from '../components/userProfileImage';
import * as activityActions from '../actions/activity';
import * as listingActions from '../actions/listings';
import { eventView } from '../components/GoogleAnalytics';

class AddComment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            commentText: "",
        };
    }

    textChange = (e) => {
        if (e && e.target) {
            this.setState({ commentText: e.target.value });
        }
    }


    submit = (event) => {
        event.preventDefault();
        this.addComment();
    }

    addComment = async () => {
        const { commentText } = this.state;
        const { activityActions, propertyId, id } = this.props;

        activityActions.addPendingComment(commentText);

        if (propertyId && commentText) {
            activityActions.addComment({ PropertyId: propertyId, Comment: commentText });
            window.sessionStorage.setItem("AddCommentPropertyId", propertyId);
        }
        else if (id && commentText) {
            activityActions.addComment({ ActivityId: id, Comment: commentText });
            window.sessionStorage.setItem("AddCommentId", id);
        }
        this.setState({ commentText: '' });
        // Register comment action with GA
        eventView('User', 'Comment');
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isCommentAdding && !nextProps.isCommentAdding) {
            this.setState({ commentText: "" });
        }

        if (!this.props.isCommentAdded && nextProps.isCommentAdded) {
            // If we updated by Activity then we want to download the activity
            if (window.sessionStorage.getItem("AddCommentId") &&
                window.sessionStorage.getItem("AddCommentId") === this.props.id) {
                window.sessionStorage.removeItem("AddCommentId");
                this.props.activityActions.fetchSingleActivity(this.props.id);
                this.props.listingActions.fetchListingById(this.props.propertyId);
                if (this.props.onAddComment) this.props.onAddComment();
                if (this.props.showNotification) {
                    this.props.showNotification(
                        "success",
                        "",
                        'Comment Added Successfully'
                    );
                }
            }

            // If we updated by PropertyId then we want to download by property Id and update the Activityid
            if (window.sessionStorage.getItem("AddCommentPropertyId") &&
                window.sessionStorage.getItem("AddCommentPropertyId") === this.props.propertyId) {
                window.sessionStorage.removeItem("AddCommentPropertyId");
                this.props.activityActions.fetchSingleActivity(this.props.id);
                this.props.listingActions.fetchListingById(this.props.propertyId);
                if (this.props.onAddComment) this.props.onAddComment();
                if (this.props.showNotification) {
                    this.props.showNotification(
                        "success",
                        "",
                        'Comment Added Successfully'
                    );
                }
            }
        }
    }

    render() {
        const { myProfile, id, isCommentAdding } = this.props;
        var photo = (myProfile && myProfile.PhotoFullUrl && myProfile.PhotoFullUrl !== "") ? myProfile.PhotoFullUrl : null;

        return (
            <div key={"cmt_add_" + id} className={this.props.className ? this.props.className + " activity_footer" : "activity_footer"}>
                <span className="d-none d-sm-inline" style={{ marginRight: '12px' }}>
                    <UserProfileImage photo={photo} id={myProfile && myProfile.Id} initials={getInitials(myProfile)} />
                </span>
                <form className="dyna-form" onSubmit={this.submit}>
                    <input type="text" placeholder="Add a comment" value={this.state.commentText} onChange={this.textChange} />
                    <button class="dyna-btn dyna-btn_mobile btn-send-comment" type='submit' disabled={isCommentAdding}>Send</button>
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({
    isCommentAdded: { ...initialState, ...state.activity }.feed.isCommentAdded,
    isCommentAdding: { ...initialState, ...state.activity }.feed.isCommentAdding
});
const mapDispatchToProps = dispatch => ({
    activityActions: bindActionCreators(activityActions, dispatch),
    listingActions: bindActionCreators(listingActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AddComment);

const initialState = {
    feed: {
        isCommentAdded: false,
        isCommentAdding: false
    }
}